import { useQuery } from 'react-query'
import { QUERIES, showError } from '../../../../../../_metronic/helpers'
import { StatCardItem, StatCards } from '../../../../../components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { getResumoAtendimentosResponsavel } from '../core/_requests'

/**
 * Totais por estado/tipo dos atendimentos filtrados (mesma query da tabela), em cards acima
 * da listagem. Só mostra as categorias que o backend devolveu.
 */
export const PersonalAtendimentosResumo = () => {
  const { query } = useQueryResponse()

  const { data: resumo } = useQuery(
    [QUERIES.MEUS_ATENDIMENTOS_RESUMO, query],
    () => getResumoAtendimentosResponsavel(query),
    { keepPreviousData: true, refetchOnWindowFocus: false, onError: showError }
  )

  if (!resumo) return null

  const items: StatCardItem[] = Object.entries(resumo)
    .filter(([, item]) => item != null)
    .map(([label, item]) => ({ label, value: item?.valor ?? 0 }))

  return <StatCards items={items} ariaLabel='Resumo dos atendimentos' />
}
